module.exports = __webpack_public_path__ + "img/avatar6.901ff375.png";